import React, { Component } from 'react';
import './../css/master.css';
import './../css/yarnCount.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var httpURL 		= '';
var queryString 	= require('querystring');
var lstYarnCount 	= [];
var COL_YARNCOUNTID = 'td:eq(0)';
var COL_YARNCOUNT 	= 'td:eq(1)';

class YarnCount extends Component {
  constructor(props){
	super(props);
	this.state={
		yarnCount:[],
		flg:true,
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=> {
	this.setState({loader:'block', opacity:0.5});  
	  axiosInstance.get(httpURL+'/a/mst/yarn/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					yarnCount:response.data.lstYarnCount,
				})
				lstYarnCount = this.state.yarnCount;
				this.setYarnCountTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  }); 
  }
  
  setYarnCountTable =()=> {
		$('#yarnCountTableBody tr').remove();
		var table 			= document.getElementById('yarnCountTable');
		var tbody 			= document.getElementById('yarnCountTableBody');
		var filterYarnCount = $('#yarnCount').val().toLowerCase();
		
		for(var i=0; i<lstYarnCount.length; i++){
		var id 			= lstYarnCount[i].yarnCountId;
		var yarnCount	= lstYarnCount[i].yarnCount;
		
		var row = document.createElement('tr');
			row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			this.setYarnCountForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(yarnCount.toLowerCase().indexOf(filterYarnCount) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, yarnCount, '');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	setYarnCountForm =(id)=> {
		var yarnCountData = this.getYarnCountData(id);
		if(yarnCountData !== -1){
			$('#inp_yarnCount').val(yarnCountData.yarnCount);
		}
	}
	
	getYarnCountData(id){
		for(var i = 0; i < lstYarnCount.length; i++){
			if(id == lstYarnCount[i].yarnCountId){
				return lstYarnCount[i];
			}
		}
		return -1;
	}
	
	addYarnCountReady =()=>{
		$('#yarnCountAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainYarnCount =()=>{
		if(this.state.flg){
			this.addYarnCount();
		}else{
			this.editYarnCount();
		}
	}
	
	addYarnCount=()=>{
	var yarnCountArr 	= {};
	var yarnCount		= $('#inp_yarnCount').val().toUpperCase();
	if(yarnCount == ''){
		toast.warning('Please fill yarn count');
		document.getElementById('inp_yarnCount').focus();
		return false;
	}
	
	yarnCountArr={'yarnCountId': 0, 'yarnCount':yarnCount}
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/a/mst/yarn/save', 
		queryString.stringify({'yarnCount':JSON.stringify(yarnCountArr)}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
			yarnCountArr.yarnCountId = response.data.yarnCountId;
			lstYarnCount.push(yarnCountArr);
			this.setYarnCountTable();
			this.setYarnCountForm(response.data.yarnCountId);
			this.highlightRow('yarnCountTableBody', response.data.yarnCountId);
			this.setState({flg : false})
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
 	}).catch((e)=>{
         toast.error("Service failed "+e);
  	});
  }

	editYarnCount=()=>{
		var yarnCountArr 	= {};
		var yarnCountId 	= $('#yarnCountTableBody tr.selected').find(COL_YARNCOUNTID).text();
		var yarnCount		= $('#inp_yarnCount').val().toUpperCase();
		
		if(yarnCountId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(yarnCount == ''){
			toast.warning('Please fill yarn count');
			document.getElementById('inp_yarnCount').focus();
			return false;
		}
		
		yarnCountArr={'yarnCountId': yarnCountId, 'yarnCount':yarnCount}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/yarn/save', 
			queryString.stringify({'yarnCount':JSON.stringify(yarnCountArr)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var yarnCountIdx = this.getIdxYarnCount(yarnCountId);
				lstYarnCount.splice(yarnCountIdx,1,yarnCountArr);
				this.setYarnCountForm(yarnCountId);
				this.setYarnCountTable();
				this.highlightRow('yarnCountTableBody', yarnCountId);
			}
			else{
		        toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxYarnCount(yarnCountId){
		for(var i=0; i<lstYarnCount.length; i++){
			if(lstYarnCount[i].yarnCountId == yarnCountId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var yarnCountId = $(this).find(COL_YARNCOUNTID).text();
			if(yarnCountId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;
	return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-7 col-centered">
						<div className="col-sm-5 col-xs-11 padding-remove">
							<table className="tableLayout">
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>yarnCount Id</th>
										<th style={{width:100}}>
											<input onChange={this.setYarnCountTable} type="text" className="form-control inp-search" id="yarnCount" placeholder="Yarn Count" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="yarnCountTableDiv col-sm-12 col-xs-11 padding-remove">
								<table id="yarnCountTable" className="tableLayout">
									<colgroup>
										<col width="100" />
									</colgroup>
									<tbody id="yarnCountTableBody"></tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addYarnCount" title="Add yarnCount" onClick={this.addYarnCountReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-6 col-xs-12">
							<form id="yarnCountAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Yarn Count:</label>
									<div className="col-sm-7">
										<input type="text" maxLength={50} className="form-control" placeholder="Yarn Count" id="inp_yarnCount"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainYarnCount} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default YarnCount;
